import { useCallback, useEffect, useState } from 'react'

import { AutenticacaoContainer, Visao } from 'src/componentes/autenticacao'
import { Api } from 'src/servicos'
import { PendenciasDocumentosAluno } from 'src/tipos'

let cache: { usuarioId: string; dados: PendenciasDocumentosAluno } | null = null
const ouvintes = new Set<() => void>()

export const invalidarPendenciasDocumentosAluno = (): void => {
  cache = null
  ouvintes.forEach(ouvinte => ouvinte())
}

export const usePendenciasDocumentosAluno = (): {
  pendencias: PendenciasDocumentosAluno | null
  carregando: boolean
  recarregar: () => Promise<void>
} => {
  const { usuario, visao } = AutenticacaoContainer.useContainer()
  const [pendencias, definirPendencias] = useState<PendenciasDocumentosAluno | null>(
    cache?.usuarioId === usuario?.id ? cache.dados : null
  )
  const [carregando, definirCarregando] = useState(false)
  const [geracao, definirGeracao] = useState(0)

  const recarregar = useCallback(async () => {
    if (!usuario?.id || visao !== Visao.Aluno || !usuario.matriculaPos) {
      definirPendencias(null)
      return
    }

    definirCarregando(true)
    try {
      const dados = await Api.ObterPendenciasDocumentosAluno(usuario.id)
      if (dados) {
        cache = { usuarioId: usuario.id, dados }
        definirPendencias(dados)
      } else {
        definirPendencias(null)
      }
    } catch {
      definirPendencias(null)
    } finally {
      definirCarregando(false)
    }
  }, [usuario?.id, usuario?.matriculaPos, visao])

  useEffect(() => {
    const ouvinte = () => definirGeracao(atual => atual + 1)
    ouvintes.add(ouvinte)
    return () => {
      ouvintes.delete(ouvinte)
    }
  }, [])

  useEffect(() => {
    recarregar()
  }, [recarregar, geracao])

  return { pendencias, carregando, recarregar }
}
